import { useEffect, useState, useCallback } from 'react';
import { t } from '../i18n';

const API = '/api/reminders';

function authHeaders() {
  const tok = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(tok ? { Authorization: `Token ${tok}` } : {}) };
}

const C = {
  ink: '#2C2C2A', muted: '#5F5E5A', border: '#E3E1D9',
  surface: '#fff', soft: '#F4F3EE', primary: '#0F6E56',
};

// Har saal aane wali cheezein — salgirah, saalgirah, barsi.
// Kaghazat (passport, CNIC) alag tab me — un ki miyaad ek dafa khatam hoti hai.
const OCCASIONS = [
  { key: 'birthday', icon: '🎂', label: 'Birthday' },
  { key: 'anniversary', icon: '💍', label: 'Anniversary' },
  { key: 'death_anniversary', icon: '🕯️', label: 'Death anniversary' },
];
const DOCS = [
  { key: 'passport', icon: '🛂', label: 'Passport' },
  { key: 'id_card', icon: '🪪', label: 'ID Card / CNIC' },
  { key: 'license', icon: '🚗', label: 'Driving License' },
  { key: 'insurance', icon: '🛡️', label: 'Insurance' },
  { key: 'biller', icon: '🧾', label: 'Bill / Subscription' },
  { key: 'domain', icon: '🌐', label: 'Domain / Website' },
  { key: 'vehicle', icon: '🚙', label: 'Vehicle Registration' },
  { key: 'other', icon: '🔔', label: 'Other' },
];
const ICON = Object.fromEntries([...OCCASIONS, ...DOCS].map((x) => [x.key, x.icon]));

const inp = {
  width: '100%', padding: '9px 11px', border: `0.5px solid #B4B2A9`,
  borderRadius: 8, fontSize: 14, marginBottom: 10, fontFamily: 'inherit',
};
const lbl = { fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 4, color: C.ink };
const btn = {
  fontSize: 13.5, padding: '8px 16px', border: 'none', borderRadius: 8,
  background: C.primary, color: '#fff', cursor: 'pointer', fontWeight: 600,
};
const ghost = {
  fontSize: 12, padding: '5px 11px', border: `0.5px solid #B4B2A9`,
  borderRadius: 8, background: '#fff', cursor: 'pointer', color: C.ink,
};

function monthKey(iso) {
  const d = new Date(iso + 'T00:00:00');
  return d.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
}
function dayNum(iso) {
  return new Date(iso + 'T00:00:00').getDate();
}
function whenText(days) {
  if (days === 0) return t('rem_today');
  if (days === 1) return t('rem_tomorrow');
  return `${days} ${t('rem_days_away')}`;
}

// ==================== Add / edit ====================
function AddModal({ initial, onClose, onSaved }) {
  const [form, setForm] = useState(initial || {
    title: '', category: 'birthday', expiry_date: '', note: '',
    username: '', notify_days_before: 3,
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const isOccasion = OCCASIONS.some((o) => o.key === form.category);

  const save = async () => {
    if (!form.title.trim() || !form.expiry_date) { setErr(t('rem_need_name_date')); return; }
    setBusy(true); setErr('');
    try {
      const url = initial && initial.id ? `${API}/${initial.id}/` : `${API}/`;
      const r = await fetch(url, {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({ ...form, is_yearly: isOccasion }),
      });
      const d = await r.json();
      if (!r.ok || d.error) throw new Error(d.error || 'Failed');
      onSaved(); onClose();
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'grid', placeItems: 'center', zIndex: 100, padding: 16 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: '1.3rem', maxWidth: 420, width: '100%', maxHeight: '88vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h3 style={{ fontSize: 16, margin: 0, color: C.ink }}>
            {initial && initial.id ? `✏️ ${t('rem_edit')}` : `➕ ${t('rem_add')}`}
          </h3>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 22, cursor: 'pointer', color: C.muted }}>×</button>
        </div>

        <label style={lbl}>{t('rem_what')}</label>
        <select style={inp} value={form.category} onChange={set('category')}>
          <optgroup label={t('rem_occasions')}>
            {OCCASIONS.map((o) => <option key={o.key} value={o.key}>{o.icon} {o.label}</option>)}
          </optgroup>
          <optgroup label={t('rem_documents')}>
            {DOCS.map((o) => <option key={o.key} value={o.key}>{o.icon} {o.label}</option>)}
          </optgroup>
        </select>

        <label style={lbl}>{isOccasion ? t('rem_whose') : t('rem_title')}</label>
        <input style={inp} value={form.title} onChange={set('title')}
          placeholder={isOccasion ? 'Maham Khalid' : 'My passport'} maxLength={200} />

        <label style={lbl}>{isOccasion ? t('rem_the_date') : t('rem_expiry')}</label>
        <input type="date" style={inp} value={form.expiry_date} onChange={set('expiry_date')} />
        {isOccasion && (
          <p style={{ fontSize: 11, color: C.muted, margin: '-6px 0 10px' }}>{t('rem_yearly_note')}</p>
        )}

        {isOccasion && (
          <>
            <label style={lbl}>{t('rem_penflow_user')}</label>
            <input style={inp} value={form.username} onChange={set('username')} placeholder="username" />
            <p style={{ fontSize: 11, color: C.muted, margin: '-6px 0 10px' }}>{t('rem_username_note')}</p>
          </>
        )}

        <label style={lbl}>{t('rem_tell_me')}</label>
        <select style={inp} value={form.notify_days_before} onChange={set('notify_days_before')}>
          <option value={0}>{t('rem_on_the_day')}</option>
          <option value={1}>1 {t('rem_day_before')}</option>
          <option value={3}>3 {t('rem_days_before')}</option>
          <option value={7}>7 {t('rem_days_before')}</option>
          <option value={14}>14 {t('rem_days_before')}</option>
          <option value={30}>30 {t('rem_days_before')}</option>
        </select>

        <label style={lbl}>{t('rem_note')}</label>
        <input style={inp} value={form.note} onChange={set('note')} maxLength={300} />

        {err && <p style={{ fontSize: 12.5, color: '#C0392B', margin: '0 0 10px' }}>{err}</p>}
        <button onClick={save} disabled={busy} style={btn}>{busy ? '…' : t('rem_save')}</button>
      </div>
    </div>
  );
}

// ==================== Ek qatar ====================
function Row({ r, onEdit, onDelete, onCard }) {
  const isOccasion = ['birthday', 'anniversary', 'death_anniversary'].includes(r.category);
  const today = r.days_until === 0;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      background: today ? '#EAF6F1' : C.surface,
      border: `0.5px solid ${today ? C.primary : C.border}`,
      borderRadius: 10, padding: '10px 12px', marginBottom: 6,
    }}>
      <div style={{
        width: 42, height: 42, borderRadius: 8, flexShrink: 0,
        background: today ? C.primary : C.soft,
        display: 'grid', placeItems: 'center', lineHeight: 1,
      }}>
        <span style={{ fontSize: 15 }}>{ICON[r.category] || '🔔'}</span>
        <span style={{ fontSize: 11, fontWeight: 700, color: today ? '#fff' : C.ink }}>{dayNum(r.date)}</span>
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: 14, fontWeight: 500, margin: 0, color: C.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {r.title}
          {r.username && <span title={t('rem_on_penflow')} style={{ fontSize: 10, marginLeft: 5, color: C.primary }}>🔗</span>}
        </p>
        <p style={{ fontSize: 11.5, color: today ? C.primary : C.muted, margin: '1px 0 0', fontWeight: today ? 600 : 400 }}>
          {whenText(r.days_until)}
          {r.turning ? ` · ${t('rem_turning')} ${r.turning}` : ''}
          {r.source === 'connection' ? ` · ${t('rem_from_profile')}` : ''}
        </p>
      </div>

      {isOccasion && (
        <button onClick={() => onCard(r)} style={{ ...btn, fontSize: 12, padding: '6px 12px', flexShrink: 0 }}>
          💌 {t('rem_send_card')}
        </button>
      )}
      {r.can_edit && (
        <>
          <button onClick={() => onEdit(r)} style={{ ...ghost, padding: '5px 8px' }} title={t('rem_edit')}>✏️</button>
          <button onClick={() => onDelete(r)} style={{ ...ghost, padding: '5px 8px', color: '#C0392B' }} title={t('rem_delete')}>🗑️</button>
        </>
      )}
    </div>
  );
}

// ==================== Safha ====================
export default function Reminders() {
  const [tab, setTab] = useState('occasions');
  const [up, setUp] = useState(null);
  const [docs, setDocs] = useState(null);
  const [adding, setAdding] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = useCallback(() => {
    fetch(`${API}/upcoming/?days=365`, { headers: authHeaders() })
      .then((r) => r.json()).then((d) => setUp(d)).catch(() => setUp({ upcoming: [], total: 0 }));
    fetch(`${API}/`, { headers: authHeaders() })
      .then((r) => r.json()).then((d) => setDocs(d.reminders || [])).catch(() => setDocs([]));
    // Jo aaj hain unki notification bana do — cron ke baghair
    fetch(`${API}/notify-due/`, { method: 'POST', headers: authHeaders() }).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const del = async (r) => {
    if (!window.confirm(t('rem_delete_confirm'))) return;
    await fetch(`${API}/${r.id}/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ action: 'delete' }) });
    load();
  };
  const sendCard = (r) => {
    const p = new URLSearchParams({ to: r.title, occasion: r.category === 'death_anniversary' ? 'sympathy' : r.category });
    if (r.username) p.set('username', r.username);
    window.location.href = `/card/new?${p}`;
  };

  if (!localStorage.getItem('token')) {
    return <div style={{ padding: '1.5rem' }}><p style={{ fontSize: 13 }}>{t('cv_please_login')}</p></div>;
  }

  // occasions ko mahine ke hisab se
  const occ = (up?.upcoming || []).filter((x) => ['birthday', 'anniversary', 'death_anniversary'].includes(x.category));
  const todayList = occ.filter((x) => x.days_until === 0);
  const later = occ.filter((x) => x.days_until > 0);
  const months = {};
  later.forEach((x) => { (months[monthKey(x.date)] ||= []).push(x); });

  const docList = (docs || []).filter((d) => !['birthday', 'anniversary', 'death_anniversary'].includes(d.category));

  const tabBtn = (k, label) => (
    <button onClick={() => setTab(k)} style={{
      fontSize: 13.5, padding: '8px 14px', border: 'none', cursor: 'pointer', background: 'none',
      borderBottom: tab === k ? `2px solid ${C.primary}` : '2px solid transparent',
      color: tab === k ? C.primary : C.muted, fontWeight: tab === k ? 600 : 400,
    }}>{label}</button>
  );

  return (
    <div style={{ padding: '1.25rem', maxWidth: 640, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
        <div>
          <h2 style={{ fontSize: 20, margin: 0, color: C.ink }}>🔔 {t('rem_title_page')}</h2>
          {up && <p style={{ fontSize: 12.5, color: C.muted, margin: '3px 0 0' }}>
            {up.total > 0 ? `${up.total} ${t('rem_upcoming')}` : t('rem_none_yet')}
          </p>}
        </div>
        <button onClick={() => setAdding(true)} style={btn}>+ {t('rem_add')}</button>
      </div>

      <div style={{ display: 'flex', gap: 2, borderBottom: `0.5px solid ${C.border}`, margin: '12px 0 14px' }}>
        {tabBtn('occasions', `🎂 ${t('rem_occasions')}${occ.length ? ` (${occ.length})` : ''}`)}
        {tabBtn('docs', `📄 ${t('rem_documents')}${docList.length ? ` (${docList.length})` : ''}`)}
      </div>

      {tab === 'occasions' && (
        <>
          {!up && <p style={{ fontSize: 13, color: C.muted }}>…</p>}
          {up && occ.length === 0 && (
            <div style={{ background: C.soft, borderRadius: 10, padding: '20px 16px', textAlign: 'center' }}>
              <p style={{ fontSize: 14, fontWeight: 500, margin: '0 0 5px', color: C.ink }}>{t('rem_empty_head')}</p>
              <p style={{ fontSize: 12.5, color: C.muted, margin: '0 0 12px', lineHeight: 1.55 }}>{t('rem_empty_body')}</p>
              <button onClick={() => setAdding(true)} style={btn}>+ {t('rem_add')}</button>
            </div>
          )}

          {todayList.length > 0 && (
            <div style={{ marginBottom: 16 }}>
              <p style={{ fontSize: 12, fontWeight: 700, color: C.primary, margin: '0 0 6px', letterSpacing: '.04em' }}>
                {t('rem_today').toUpperCase()}
              </p>
              {todayList.map((r) => (
                <Row key={`${r.source}${r.id}`} r={r} onEdit={setEditing} onDelete={del} onCard={sendCard} />
              ))}
            </div>
          )}

          {Object.entries(months).map(([m, rows]) => (
            <div key={m} style={{ marginBottom: 16 }}>
              <p style={{ fontSize: 12, fontWeight: 700, color: C.muted, margin: '0 0 6px', letterSpacing: '.04em' }}>
                {m.toUpperCase()}
              </p>
              {rows.map((r) => (
                <Row key={`${r.source}${r.id}`} r={r} onEdit={setEditing} onDelete={del} onCard={sendCard} />
              ))}
            </div>
          ))}

          {occ.some((x) => x.source === 'connection') && (
            <p style={{ fontSize: 11, color: C.muted, borderTop: `0.5px solid ${C.border}`, paddingTop: 10, lineHeight: 1.5 }}>
              {t('rem_auto_note')}
            </p>
          )}
        </>
      )}

      {tab === 'docs' && (
        <>
          {!docs && <p style={{ fontSize: 13, color: C.muted }}>…</p>}
          {docs && docList.length === 0 && (
            <p style={{ fontSize: 13, color: C.muted }}>{t('rem_no_docs')}</p>
          )}
          {docList.map((r) => {
            const late = r.days_left < 0;
            const soon = r.days_left >= 0 && r.days_left <= 30;
            return (
              <div key={r.id} style={{
                display: 'flex', alignItems: 'center', gap: 12,
                background: late ? '#FDF2F0' : C.surface,
                border: `0.5px solid ${late ? '#C0392B' : C.border}`,
                borderRadius: 10, padding: '10px 12px', marginBottom: 6,
              }}>
                <span style={{ fontSize: 19 }}>{ICON[r.category] || '🔔'}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontSize: 14, fontWeight: 500, margin: 0, color: C.ink }}>{r.title}</p>
                  <p style={{ fontSize: 11.5, margin: '1px 0 0', color: late ? '#C0392B' : soon ? '#9A6B00' : C.muted }}>
                    {late ? `${t('rem_expired')} · ${r.expiry_date}` : `${r.days_left} ${t('rem_days_left')} · ${r.expiry_date}`}
                  </p>
                </div>
                <button onClick={() => setEditing({ ...r, expiry_date: r.expiry_date })} style={{ ...ghost, padding: '5px 8px' }}>✏️</button>
                <button onClick={() => del(r)} style={{ ...ghost, padding: '5px 8px', color: '#C0392B' }}>🗑️</button>
              </div>
            );
          })}
        </>
      )}

      {adding && <AddModal onClose={() => setAdding(false)} onSaved={load} />}
      {editing && <AddModal initial={editing} onClose={() => setEditing(null)} onSaved={load} />}
    </div>
  );
}
